import React from "react";
import "./Css/Credits.css";
import Navigation from "./Navigation";
import Footer from "./Footer";

const Credits = () => {
  const creditsPage = () => {
    return (
      <div>
        <section className="credits">
          <div className="creditsCard">
            <div>
              <h1 className="heading">Credits</h1>
            </div>
            <div>
              <p className="desc">
                <span>Disclaimer</span>:- All copyrights and trademarks of the
                Ben10 characters,images and information used belong to their
                respective owners and are not being sold. This item is not a
                licensed product and I do not claim ownership over the
                characters,images and information used in my website or API. The
                project was intended for fun purposes only.
              </p>
            </div>

            <div>
              <p className="imgNotice">
                <span>Regarding Images</span>:- Before using any images provided
                by API please remember you have to attribute it with image
                credits provided in API.
              </p>
            </div>

            <div className="attribution">
              <span>Sample attribution</span>:-
              <pre className="sample">
                <code>
                  {`<a href={imageCredits}><img src={image} alt="image" /></a>`}
                </code>
              </pre>
              <h3 className="thanku">Thank You 😀</h3>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <Navigation />
      {creditsPage()}
      <Footer />
    </div>
  );
};

export default Credits;
